// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Phr_","right":"styles_right__2EPgZ"};